import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  () => ({
    container: { padding: "32px 88px 170px 88px" },
    pageHeader: {
      marginBottom: 24,
      display: "flex",
      justifyContent: "space-between"
    },
    headerPageLogo: {
      display: "flex",
      alignItems: "center",
      transition: "all 0.5s ease",
      height: 35
    },
    scgpLogo: {
      paddingRight: 23,
      height: 12.5
    },
    eOrderingLogo: {
      paddingLeft: 23,
      borderLeft: "solid 1px #E41B17",
      height: "100%"
    },
    pageHeaderLogo: {},
    checkCircleIcon: {
      marginRight: 15,
      width: 22,
      height: 22
    },
    headerTitle: {
      display: "flex",
      alignItems: "end",
      justifyContent: "space-between",
      marginBottom: 24
    },
    headerContent: {
      fontSize: 28,
      display: "inline-block"
    }
  }),
  { name: "PreviewOrder" }
);
export default useStyles;
